import type { TFunction } from "i18next";

export enum SchemaPinType {
  TABLE = "table",
  RUN_CHART = "runChart",
  BY_ASSET_AGE = "byAssetAge",
  TOP_CONTRIBUTORS = "topContributors",
}
export const MORE_BUTTON_WIDTH = 200;
export const getSchemaPinDefaultTitles = (
  t: TFunction
): Record<SchemaPinType, string> => ({
  [SchemaPinType.TABLE]: t("investigator.pin_title_related_records"),
  [SchemaPinType.RUN_CHART]: t("investigator.pin_title_occurrence_date"),
  [SchemaPinType.BY_ASSET_AGE]: t("investigator.pin_title_production_date"),
  [SchemaPinType.TOP_CONTRIBUTORS]: t(
    "investigator.pin_title_top_contributors"
  ),
});

export const NEW_PIN_ID = "new";
export const DEFAULT_ASSET_SCHEMA_NAME = "vehicle";

export const SCHEMA_INVESTIGATOR_INVESTIGATION_ID_KEY = "investigationId";
export const SCHEMA_INVESTIGATOR_EVENT_FILTER_KEY = "eventFilter";
export const SCHEMA_INVESTIGATOR_ASSET_FILTER_KEY = "assetFilter";
export const SCHEMA_INVESTIGATOR_SMART_GROUP_ID_KEY = "smartGroupId";

export const SCHEMA_INVESTIGATOR_FILTERS_LOCALSTORAGE_KEY =
  "schema-investigator-filters";

/**
 * Auto-close duration (ms) used for all toast notifications on the
 * SchemaInvestigator page. Kept short so quick consecutive actions
 * (pin/unpin, save) don't stack visible toasts.
 */
export const SCHEMA_INVESTIGATOR_TOAST_OPTIONS = { autoClose: 1000 };
